import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

export default function TerminiServizio() {
  const lastUpdate = "23 settembre 2026";
  return (
    <div className="max-w-4xl mx-auto px-6 py-10" data-testid="terms-page">
      <div className="flex items-center gap-3 mb-2">
        <FileText className="w-8 h-8 text-labor-olive" />
        <div className="text-xs uppercase tracking-widest text-labor-muted">Documento legale</div>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl mb-2">Termini di Servizio</h1>
      <p className="text-labor-muted text-sm mb-8">
        Condizioni d'uso dell'app Labor AI · Ultimo aggiornamento: {lastUpdate}
      </p>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">1. Oggetto del servizio</h2>
        <p className="text-sm leading-relaxed">
          Labor AI è l'app del <strong>CAF Patronato Labor di Bitonto</strong> (Via Zuavo n. 12 · 70032 Bitonto BA) che
          consente di prenotare appuntamenti, dialogare con un assistente virtuale informativo, acquistare crediti
          Labor Point per l'uso del chatbot e ricevere documenti dagli operatori. Il servizio è disponibile a
          persone maggiorenni residenti in Italia.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">2. Accettazione dei termini</h2>
        <p className="text-sm leading-relaxed">
          Registrandoti e usando l'app dichiari di aver letto e accettato integralmente i presenti Termini e la
          nostra <Link to="/privacy-policy" className="text-labor-olive hover:underline">Privacy Policy</Link>.
          Se non sei d'accordo, ti chiediamo di non usare il servizio.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">3. Account e obblighi dell'utente</h2>
        <ul className="text-sm space-y-1 list-disc list-inside text-labor-muted">
          <li>Fornisci dati veritieri, aggiornati e riferiti alla tua persona (nome, cognome, email, telefono valido).</li>
          <li>Custodisci con cura le tue credenziali (password e/o PIN). Sei responsabile delle attività svolte con il tuo account.</li>
          <li>Non usare l'app per scopi illeciti, offensivi o lesivi dei diritti altrui.</li>
          <li>Non cercare di aggirare i limiti tecnici, i costi in Labor Point o le regole di prenotazione.</li>
          <li>Il CAF può sospendere o eliminare l'account in caso di abusi, dati fittizi o mancato pagamento.</li>
        </ul>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">4. Labor AI (assistente virtuale)</h2>
        <p className="text-sm leading-relaxed">
          Labor AI fornisce risposte di carattere informativo generico basate su una knowledge base curata dal CAF
          e su un modello di intelligenza artificiale. <strong>Le risposte non sostituiscono la consulenza
          professionale</strong>: per pratiche specifiche prenota un appuntamento in sede. Il CAF non risponde di
          eventuali decisioni prese dall'utente sulla base delle sole risposte del chatbot.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">5. Labor Point e pagamenti</h2>
        <ul className="text-sm space-y-1 list-disc list-inside text-labor-muted">
          <li>All'iscrizione ricevi <strong>20 domande gratuite</strong>. Terminate, ogni risposta consuma da 1 a 8 Labor Point.</li>
          <li>I Labor Point sono acquistabili in pacchetti tramite <strong>Stripe</strong>. Il prezzo di ogni pacchetto è quello indicato al momento dell'acquisto.</li>
          <li>I Labor Point sono un credito digitale interno, <strong>non convertibile in denaro</strong> e non trasferibile ad altri account.</li>
          <li>I Labor Point non hanno scadenza fintanto che il tuo account resta attivo.</li>
          <li>In caso di malfunzionamento tecnico che comporti un consumo di Labor Point non giustificato, il CAF ricrediterà i punti dopo verifica scrivendo a caflaborvitobitonto@gmail.com.</li>
        </ul>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">6. Diritto di recesso e rimborsi</h2>
        <p className="text-sm leading-relaxed">
          I Labor Point sono un servizio digitale erogato immediatamente. Ai sensi dell'art. 59, lett. o) del
          Codice del Consumo, avviando l'utilizzo dei Labor Point (prima domanda pagata a Labor AI) l'utente
          rinuncia al diritto di recesso relativo alla parte di credito già consumata. I punti non consumati
          possono essere rimborsati entro 14 giorni dall'acquisto scrivendo a caflaborvitobitonto@gmail.com.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">7. Prenotazioni e regole di cortesia</h2>
        <ul className="text-sm space-y-1 list-disc list-inside text-labor-muted">
          <li>La prenotazione è confermata solo dopo la ricezione dell'email di conferma.</li>
          <li>Cancella o modifica un appuntamento con almeno 12 ore di anticipo per liberare lo slot ad altri.</li>
          <li>Ripetute assenze non giustificate ("no-show") possono comportare la sospensione della possibilità di prenotare.</li>
        </ul>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">8. Limitazione di responsabilità</h2>
        <p className="text-sm leading-relaxed">
          Il servizio è fornito "così com'è". Nei limiti consentiti dalla legge, il CAF Patronato Labor non
          risponde di danni indiretti, mancati guadagni o perdita di dati derivanti dall'uso o dall'impossibilità
          di utilizzare l'app, salvo il caso di dolo o colpa grave.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">9. Chiusura dell'account</h2>
        <p className="text-sm leading-relaxed">
          Puoi eliminare in qualsiasi momento il tuo account dalla sezione <strong>Profilo → Elimina account</strong>
          oppure scrivendo a <strong>caflaborvitobitonto@gmail.com</strong>. La cancellazione è definitiva ed
          eventuali Labor Point residui vengono persi (salvo richiesta di rimborso ex art. 6).
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">10. Modifiche</h2>
        <p className="text-sm leading-relaxed">
          Il CAF può modificare in qualunque momento i presenti Termini per adeguarli a novità di servizio o
          normative. Le modifiche saranno pubblicate in questa pagina; l'uso continuato del servizio dopo la
          pubblicazione costituisce accettazione delle modifiche.
        </p>
      </section>

      <section className="paper-card p-6 mb-6">
        <h2 className="font-display text-2xl mb-3">11. Legge applicabile e foro competente</h2>
        <p className="text-sm leading-relaxed">
          I presenti Termini sono regolati dalla legge italiana. Per le controversie con consumatori è competente
          il foro del luogo di residenza o domicilio dell'utente consumatore. Per gli altri casi è competente in
          via esclusiva il Foro di Bari.
        </p>
      </section>

      <div className="text-center mt-8">
        <Link to="/" className="text-labor-olive hover:underline text-sm">← Torna alla home</Link>
      </div>
    </div>
  );
}
